import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuthStore } from '@/store/auth'
import { authApi } from '@/lib/api'
import { Loader2 } from 'lucide-react'

// Same-origin relative paths only — mirrors the backend guard (anti open-redirect).
function safeNext(next: string | null): string {
  if (!next || !next.startsWith('/') || next.startsWith('//')) return '/'
  return next
}

export default function AuthCallback() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { setUser } = useAuthStore()

  useEffect(() => {
    // Tokens arrive as httpOnly cookies set by the backend redirect:
    // verifying the session via /auth/me is all that is needed here.
    authApi
      .getMe()
      .then((user) => {
        setUser(user)
        navigate(safeNext(searchParams.get('next')))
      })
      .catch(() => {
        navigate('/login')
      })
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <Loader2 className="w-10 h-10 animate-spin text-mim-blue mx-auto" />
        <p className="text-muted-foreground">Accesso in corso…</p>
      </div>
    </div>
  )
}
